/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Detail_Meta_LabelInputs */

const en_prompt_detail_meta_label = /** @type {(inputs: Prompt_Detail_Meta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt`)
};

const es_prompt_detail_meta_label = /** @type {(inputs: Prompt_Detail_Meta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt`)
};

/**
* | output |
* | --- |
* | "Prompt" |
*
* @param {Prompt_Detail_Meta_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const prompt_detail_meta_label = /** @type {((inputs?: Prompt_Detail_Meta_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Detail_Meta_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_prompt_detail_meta_label(inputs)
	return es_prompt_detail_meta_label(inputs)
});